module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_plan_show_bg_03-aeb1df0e0a03bb4fce98706bac4bc7e6.jpg";